import SectionStack from 'components/common/SectionStack'
import { Body1, Body2 } from 'components/typography'
import { FC } from 'react'

const CompanyInfoSection: FC = () => {
  return (
    <SectionStack>
      <Body1 color="alabaster" pb="4px" borderBottom="2px solid #25241E">
        Sobre a Omens
      </Body1>
      <Body2 color="alabaster">
        A Omens é uma plataforma de intermediação de saúde dedicada ao homem. Ela reúne especialistas brasileiros,
        urologistas e farmacêuticos para construir uma solução de qualidade, segura e acessível para todos. A Omens é
        uma empresa registrada no CNPJ 38.143.501/0001-08 no Brasil, com sede em São Paulo. Seus dados são coletados e
        processados por um servidor de hospedagem certificado e aprovado.
      </Body2>
      <Body2 color="alabaster">
        O Encarregado pelo Tratamento de Dados Pessoais (DPO) é o responsável pela proteção dos dados pessoais tratados
        pela Omens. Para assuntos relacionados à LGPD ou para o exercício dos direitos previstos no art. 18 da Lei nº
        13.709/2018 pelos titulares de dados, o DPO pode ser contatado pelo e-mail dpo@omens.com.br.
      </Body2>
      <Body2 color="alabaster">© 2026 Omens. Todos os direitos reservados.</Body2>
    </SectionStack>
  )
}

export default CompanyInfoSection
